import { Component, OnInit } from '@angular/core';
import { BzgModalService } from 'bz-genome-angular';

@Component({
  selector: 'biz-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.scss']
})
export class ListUsersComponent implements OnInit {

  constructor(private _modalService: BzgModalService) { }

  ngOnInit() {
  }

}
